import angular from 'angular';
import template from './template.html';
import './style.scss';
import './step';
import './feedback-step';
import { RECRUITER_WORKFLOW_STATUS } from '../../recruiter/constants/recruiter-workflow';

export class CandidateWorkflowSteps {
    /* @ngInject */
    constructor($filter) {
        this.$filter = $filter;
    }

    $onChanges() {
        if (!this.workflowData) {
            return;
        }

        const workflowData = this.workflowData.data;
        const { status } = this;

        this.workflowStepsSplitted = (this.workflowSteps || []).reduce((accumulator, workflow) => {
            const count = this.getCandidateWorkflowCount(workflowData, status, workflow.step);

            const workflowStepWithCount = {
                ...workflow,
                count,
            };

            const isChainedStep = workflow.step !== RECRUITER_WORKFLOW_STATUS.REJECTED;
            return {
                chained: isChainedStep ? [...accumulator.chained, workflowStepWithCount] : accumulator.chained,
                unchained: !isChainedStep ? [...accumulator.unchained, workflowStepWithCount] : accumulator.unchained,
            };
        }, { chained: [], unchained: [] });
    }

    getCandidateWorkflowCount(workflowData, status, workflowStep) {
        const { $filter } = this;
        const getWorkflowCountByType = $filter('getWorkflowCountByType');

        return getWorkflowCountByType(workflowData, status, workflowStep);
    }
}

export const CandidateWorkflowStepsConfiguration = {
    template,
    bindings: {
        workflowSteps: '<',
        workflowData: '<',
        selectedWorkflow: '<',
    },
    controller: CandidateWorkflowSteps,
    controllerAs: 'candidateWorkflowStepsCtrl',
};

angular
    .module('TALENYA-FE')
    .component('candidateWorkflowSteps', CandidateWorkflowStepsConfiguration);
